import { Rect, Circle, Group, Line } from 'react-konva';
import PropTypes from 'prop-types';
import React from 'react';
import annTools from './commonAnnotationTools';
const selectColor = 'rgb(22,114,84)';

// must be defined outside of the component to avoid re-rendering loops
const defaultOnDragMove = () => {};
const defaultBox = {};
const defaultEnds = [];
const Annotation = _ref => {
  let selectedID = _ref.selectedID,
    annotationID = _ref.annotationID,
    children = _ref.children,
    onDragEnd = _ref.onDragEnd,
    _ref$onDragMove = _ref.onDragMove,
    onDragMove = _ref$onDragMove === void 0 ? defaultOnDragMove : _ref$onDragMove,
    _ref$draggable = _ref.draggable,
    draggable = _ref$draggable === void 0 ? false : _ref$draggable,
    _ref$box = _ref.box,
    box = _ref$box === void 0 ? defaultBox : _ref$box,
    _ref$hideSelectionBox = _ref.hideSelectionBox,
    hideSelectionBox = _ref$hideSelectionBox === void 0 ? false : _ref$hideSelectionBox,
    _ref$scalable = _ref.scalable,
    scalable = _ref$scalable === void 0 ? false : _ref$scalable,
    scale = _ref.scale,
    _ref$ends = _ref.ends,
    ends = _ref$ends === void 0 ? defaultEnds : _ref$ends,
    _ref$dpiScale = _ref.dpiScale,
    dpiScale = _ref$dpiScale === void 0 ? 1 : _ref$dpiScale;
  const isSelected = selectedID === annotationID;
  const pixelOffset = annTools.selectionOffset * scale / dpiScale;
  const adjustX = (box.x - pixelOffset) / dpiScale;
  const adjustY = (box.y - pixelOffset) / dpiScale;
  const adjustW = (box.w + 2 * pixelOffset) / dpiScale;
  const adjustH = (box.h + 2 * pixelOffset) / dpiScale;
  let cornerAnchors = [];
  if (isSelected && scalable) {
    if (ends && ends.length) {
      cornerAnchors = [{
        x: ends[0][0],
        y: ends[0][1],
        key: 'beginning'
      }, {
        x: ends[1][0],
        y: ends[1][1],
        key: 'end'
      }];
    } else {
      cornerAnchors = [{
        x: adjustX,
        y: adjustY,
        key: 'ul'
      }, {
        x: adjustX + adjustW,
        y: adjustY,
        key: 'ur'
      }, {
        x: adjustX + adjustW,
        y: adjustY + adjustH,
        key: 'lr'
      }, {
        x: adjustX,
        y: adjustY + adjustH,
        key: 'll'
      }];
    }
  }
  const largeCircleDiameter = 15 * scale / dpiScale;
  const smallCircleDiameter = 20 / dpiScale; // don't scale selection knobs with zoom

  const endSelect = cornerAnchors.length === 2;
  const circleDiameter = endSelect ? largeCircleDiameter : smallCircleDiameter;
  return /*#__PURE__*/React.createElement(Group, {
    draggable: isSelected && draggable,
    name: annotationID,
    onDragEnd: onDragEnd
  }, endSelect ? /*#__PURE__*/React.createElement(Line, {
    key: "".concat(annotationID, "-selection-tube"),
    points: [cornerAnchors[0].x, cornerAnchors[0].y, cornerAnchors[1].x, cornerAnchors[1].y],
    stroke: selectColor,
    strokeWidth: 40 * scale,
    opacity: 0.1,
    lineCap: "round"
  }) : null, children, isSelected && !hideSelectionBox && !endSelect ? /*#__PURE__*/React.createElement(Rect, {
    x: adjustX,
    y: adjustY,
    width: adjustW,
    height: adjustH,
    strokeWidth: 4,
    stroke: selectColor
  }) : null, cornerAnchors.map(next => /*#__PURE__*/React.createElement(Circle, {
    draggable: isSelected && draggable,
    onDragMove: onDragMove,
    key: "".concat(next.key, "-knob"),
    name: next.key,
    x: next.x,
    y: next.y,
    width: circleDiameter,
    height: circleDiameter,
    fill: selectColor
  })));
};
Annotation.propTypes = {
  annotationID: PropTypes.string.isRequired,
  box: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    h: PropTypes.number,
    w: PropTypes.number
  }),
  ends: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  children: PropTypes.node.isRequired,
  onDragMove: PropTypes.func,
  draggable: PropTypes.bool,
  hideSelectionBox: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
  scalable: PropTypes.bool,
  selectedID: PropTypes.string.isRequired,
  scale: PropTypes.number.isRequired,
  dpiScale: PropTypes.number
};
export default Annotation;